import { FetchStatsRoutine } from '../redux-routines';

export const initialState = {
  isFetching: false,
  data: {
    product: {},
    aggregatedData: {},
    companies: [],
    topLicenses: []
  },
  error: null
};

export const aggregatedStatsReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case FetchStatsRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case FetchStatsRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
        error: null
      };
    case FetchStatsRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };
    default:
      return state;
  }
};
